import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "./deviceNav.css";
import { Link, withRouter } from 'react-router-dom';

const dropdownData = [
  {
    id: 1,
    label: "iPhones",
    options: [
      { label: "iPhone 16 Pro Max", href: "/iPhone/iPhone 16 Pro Max" },
      { label: "iPhone 16 Pro", href: "/iPhone/iPhone 16 Pro" },
      { label: "iPhone 16 Plus", href: "/iPhone/iPhone 16 Plus" },
      { label: "iPhone 16", href: "/iPhone/iPhone 16" },
      { label: "iPhone 15 Pro Max", href: "/iPhone/iPhone 15 Pro Max" },
      { label: "iPhone 15 Pro", href: "/iPhone/iPhone 15 Pro" },
      { label: "iPhone 15 Plus", href: "/iPhone/iPhone 15 Plus" },
      { label: "iPhone 15", href: "/iPhone/iPhone 15" },
      { label: "iPhone 14 Pro Max", href: "/iPhone/iPhone 14 Pro Max" },
      { label: "iPhone 14 Pro", href: "/iPhone/iPhone 14 Pro" },
      { label: "iPhone 14 Plus", href: "/iPhone/iPhone 14 Plus" },
      { label: "iPhone 14", href: "/iPhone/iPhone 14" },
      { label: "iPhone SE (3rd)", href: "/iPhone/iPhone SE 3rd" },
      { label: "iPhone 13 Pro Max", href: "/iPhone/iPhone 13 Pro Max" },
      { label: "iPhone 13 Pro", href: "/iPhone/iPhone 13 Pro" },
      { label: "iPhone 13", href: "/iPhone/iPhone 13" },
      { label: "iPhone 13 Mini", href: "/iPhone/iPhone 13 Mini" },
      { label: "iPhone 12 Pro Max", href: "/iPhone/iPhone 12 Pro Max" },
      { label: "iPhone 12 Pro", href: "/iPhone/iPhone 12 Pro" },
      { label: "iPhone 12", href: "/iPhone/iPhone 12" },
      { label: "iPhone 12 Mini", href: "/iPhone/iPhone 12 Mini" },
      { label: "iPhone SE (2nd)", href: "/iPhone/iPhone SE 2nd" },
      { label: "iPhone 11 Pro Max", href: "/iPhone/iPhone 11 Pro Max" },
      { label: "iPhone 11 Pro", href: "/iPhone/iPhone 11 Pro" },
      { label: "iPhone 11", href: "/iPhone/iPhone 11" },
      { label: "iPhone XS Max", href: "/iPhone/iPhone XS Max" },
      { label: "iPhone XS", href: "/iPhone/iPhone XS" },
      { label: "iPhone XR", href: "/iPhone/iPhone XR" },
      { label: "iPhone X", href: "/iPhone/iPhone X" },
      { label: "iPhone 8 Plus", href: "/iPhone/iPhone 8 Plus" },
      { label: "iPhone 8", href: "/iPhone/iPhone 8" },
      { label: "iPhone 7 Plus", href: "/iPhone/iPhone 7 Plus" },
      { label: "iPhone 7", href: "/iPhone/iPhone 7" },
      { label: "iPhone SE (1st)", href: "/iPhone/iPhone SE 1st" },
      { label: "iPhone 6s Plus", href: "/iPhone/iPhone 6S Plus" },
    ],
  },
  {
    id: 2,
    label: "MacBooks",
    options: [
      { label: "MacBook", href: "/Macbook/Macbook" },
      { label: "MacBook Air", href: "/Macbook/Macbook Air" },
      { label: "MacBook Pro", href: "/Macbook/Macbook Pro" },
    ],
  },
  {
    id: 3,
    label: "iPads",
    options: [
      { label: "iPad Pro", href: "/iPad/iPad Pro" },
      { label: "iPad Mini", href: "/iPad/iPad Mini" },
      { label: "iPad Air", href: "/iPad/iPad Air" },
      { label: "iPad", href: "/iPad/iPad" },
    ],
  },
  {
    id: 4,
    label: "Apple iWatch",
    options: [
      { label: "iWatch Series 10", href: "/iWatch/Apple Watch (Series 10)" },
      { label: "iWatch Ultra 2", href: "/iWatch/Apple Watch Ultra 2" },
      { label: "iWatch Series 9", href: "/iWatch/Apple Watch (Series 9)" },
      { label: "iWatch Ultra", href: "/iWatch/Apple Watch Ultra" },
      { label: "iWatch SE 2nd Gen", href: "/iWatch/Apple Watch (SE) 2nd Gen." },
      { label: "iWatch Series 8", href: "/iWatch/Apple Watch (Series 8)" },
      { label: "iWatch Series 7", href: "/iWatch/Apple Watch (Series 7)" },
      { label: "iWatch Series 6", href: "/iWatch/Apple Watch (Series 6)" },
      { label: "iWatch Series 5", href: "/iWatch/Apple Watch (Series 5)" },
    ],
  },
  {
    id: 5,
    label: "AirPods",
    options: [
      { label: "AirPods Pro (2nd Gen.)", href: "/Airpods/AirPods Pro (2nd Gen.)" },
      { label: "AirPods Pro (1st Gen.)", href: "/Airpods/AirPods Pro (1st Gen.)" },
      { label: "AirPods (3rd Gen.)", href: "/Airpods/AirPods (3rd Gen.)" },
      { label: "AirPods Max", href: "/Airpods/AirPods Max" },
      { label: "HomePod (2nd Gen.)", href: "/Airpods/HomePod (2nd Gen.)" },
      { label: "AirPods (4th Gen.)", href: "/Airpods/AirPods (4th Gen.)" },
      {
        label: "AirPods (4th Gen.) Active Noise Cancellation",
        href: "/Airpods/AirPods (4th Gen.) Active Noise Cancellation",
      },
    ],
  },
];

const DropdownPortal = ({ options, anchorRef, onClose }) => {
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !anchorRef.current.contains(e.target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose, anchorRef]);

  const anchorRect = anchorRef.current?.getBoundingClientRect();

  return ReactDOM.createPortal(
    <div
      ref={menuRef}
      className="dropdown-options-portal"
      style={{
        top: `${anchorRect.bottom + window.scrollY}px`,
        left: `${anchorRect.left + window.scrollX}px`,
      }}
    >
      {options.map((opt, idx) => (
        <Link
          key={idx}
          className="dropdown-option"
          to={opt.href}
      
          rel="noopener noreferrer"
        >
          {opt.label}
        </Link>
      ))}
    </div>,
    document.body
  );
};

const HorizontalDropdowns = () => {
  const [openId, setOpenId] = useState(null);
  const buttonRefs = useRef({});

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="scroll-container">
      {dropdownData.map((dropdown) => (
        <div key={dropdown.id} className="dropdown-wrapper">
          <button
            ref={(el) => (buttonRefs.current[dropdown.id] = el)}
            className="dropdown-label"
            onClick={() => handleToggle(dropdown.id)}
          >
            {dropdown.label}
          </button>

          {openId === dropdown.id && (
            <DropdownPortal
              options={dropdown.options}
              anchorRef={{ current: buttonRefs.current[dropdown.id] }}
              onClose={() => setOpenId(null)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default HorizontalDropdowns;
